import unitStatus from './unitStatus'
import formatter from '../constants/currencyFormatter'

const unitFilter = (units, searchTerm, isAuditUnitSearch = false) => {
  const validUnits = (units ?? []).filter((unit) => unit?.attributes)

  if (!searchTerm.trim()) return validUnits

  const searchTerms = searchTerm.toLowerCase().split(/\s+/)

  const matchesFilter = (unit, parameter, term) => {
    return unit.attributes[parameter]?.toString().toLowerCase().includes(term)
  }

  return validUnits.filter((unit) => {
    return searchTerms.every((term) => {
      return (
        matchesFilter(unit, 'make', term) ||
        matchesFilter(unit, 'model', term) ||
        matchesFilter(unit, 'vin', term) ||
        matchesFilter(unit, 'color', term) ||
        matchesFilter(unit, 'year', term) ||
        (!isAuditUnitSearch && (
          unitStatus(unit).text.toLowerCase().includes(term) ||
          formatter.format(unit.attributes.payoff).includes(term) ||
          formatter.format(unit.attributes.curtailment).includes(term)
        ))
      )
    })
  })
}

export default unitFilter
